/**
 * ScrollToTop — scroll the window to (0,0) on every route change.
 *
 * React Router does not restore scroll position by default; without this
 * component, navigating between long pages leaves the browser scrolled
 * to whatever position the previous page ended at. Executive Directive:
 * "all pages must load at the top."
 */
import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export function ScrollToTop(): null {
  const { pathname, search } = useLocation();
  useEffect(() => {
    // ``instant`` avoids the smooth-scroll flash on route changes.
    window.scrollTo({ top: 0, left: 0, behavior: "instant" as ScrollBehavior });
  }, [pathname, search]);
  return null;
}
